import React, { useState, useEffect } from 'react';
import { CustomModal } from '../../../../common/CustomModal';
import i18n from '../../../../../i18n';

export const InvoiceDateModal = ({ show, auction, onClose, onSave, loading }) => {
  const [invoiceDate, setInvoiceDate] = useState('');

  useEffect(() => {
    if (auction) {
      setInvoiceDate(auction.invoice_date || '');
    }
  }, [auction]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!invoiceDate) return;
    onSave(invoiceDate);
  };

  return (
    <CustomModal
      isOpen={show}
      header={i18n.t('edit_invoice_date')}
      onClose={onClose}
      modalClassName={'modal-l2-sm'}
    >
      <form onSubmit={handleSubmit} className="invoice-date-form">
        {auction && (
          <p className="invoice-date-auction-info">
            {i18n.t('mzad_id')}: MZAD {auction.id}
          </p>
        )}

        <div className="select-wrapper floating-label-wrapper">
          <input
            id="invoiceDate"
            type="date"
            name="invoiceDate"
            value={invoiceDate}
            onChange={(e) => setInvoiceDate(e.target.value)}
            className="filter-base floating-input"
            placeholder=" "
            required
          />
          <label htmlFor="invoiceDate" className="floating-label">
            {i18n.t('invoice_date')}
          </label>
        </div>

        <div className="modal-actions">
          <button
            type="button"
            className="button1 button1-gray"
            onClick={onClose}
            disabled={loading}
          >
            {i18n.t('cancel')}
          </button>
          <button
            type="submit"
            className="button1 button1-primary"
            disabled={loading || !invoiceDate}
          >
            {loading ? (
              <>
                {i18n.t('save')}
                <span className="spinner" />
              </>
            ) : (
              i18n.t('save')
            )}
          </button>
        </div>
      </form>
    </CustomModal>
  );
};
